// Packages

// Components
import { CookiesConsent } from "./CookiesConsent/CookiesConsent";

// Logic

// Context

// Services

// Styles

// Assets

export const Cookies = () => {
	return (
		<div className='settings-subpage'>
			<CookiesConsent />
		</div>
	);
};
